import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface CreditCardSubscriptionProps {
  recurlyToken: string
}

const updatePaymentInformation = (values: CreditCardSubscriptionProps): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/CompanySettings/CompanySubscription/UpdatePaymentInfo', values)
}

export default updatePaymentInformation
